import { render } from "./Utenti.vue?vue&type=template&id=bf1da4ce&scoped=true"
import script from "./Utenti.vue?vue&type=script&lang=js"
export * from "./Utenti.vue?vue&type=script&lang=js"

import "./Utenti.vue?vue&type=style&index=0&id=bf1da4ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf1da4ce"]])

export default __exports__